import axios from "axios";

// Commerce abstraction layer.
// source = "mock"    -> CAFÉXIR mock catalog served by the local API (default, pre-Shopify)
// source = "shopify" -> Shopify Storefront API (see ./shopify.js). Switch by setting
//                       REACT_APP_COMMERCE_SOURCE=shopify plus the storefront env vars.
export const commerceSource = process.env.REACT_APP_COMMERCE_SOURCE || "mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchProducts() {
  if (commerceSource === "shopify") {
    const { fetchShopifyProducts } = await import("./shopify");
    return fetchShopifyProducts();
  }
  const { data } = await axios.get(`${API}/products`);
  return data;
}

export async function fetchProduct(handle) {
  if (commerceSource === "shopify") {
    const { fetchShopifyProduct } = await import("./shopify");
    return fetchShopifyProduct(handle);
  }
  const { data } = await axios.get(`${API}/products/${handle}`);
  return data;
}

export async function fetchStoreSettings() {
  const { data } = await axios.get(`${API}/settings/public`);
  return data;
}

export async function placeOrder(payload, idempotencyKey) {
  const { data } = await axios.post(`${API}/orders`, payload, {
    headers: { "Idempotency-Key": idempotencyKey },
    withCredentials: true,
  });
  return data;
}

export async function fetchMyOrders() {
  const { data } = await axios.get(`${API}/orders/mine`, { withCredentials: true });
  return data;
}

export async function assessCupprint(sessionId, answers) {
  const { data } = await axios.post(`${API}/cupprint/assess`, { session_id: sessionId, answers }, { withCredentials: true });
  return data;
}

export async function fetchCupprintProfile(sessionId) {
  try {
    const { data } = await axios.get(`${API}/cupprint/profile`, { params: { session_id: sessionId } });
    return data;
  } catch {
    return null;
  }
}

export async function sendCupprintFeedback(sessionId, handle, liked) {
  const { data } = await axios.post(`${API}/cupprint/feedback`, { session_id: sessionId, handle, liked });
  return data;
}

export async function fetchContent() {
  try {
    const { data } = await axios.get(`${API}/content`);
    return data;
  } catch {
    return {};
  }
}

const adminCfg = { withCredentials: true };
export const adminApi = {
  listOrders: async () => (await axios.get(`${API}/admin/orders`, adminCfg)).data,
  updateOrder: async (orderNumber, status, adminNotes = "") =>
    (await axios.put(`${API}/admin/orders/${orderNumber}`, { status, admin_notes: adminNotes }, adminCfg)).data,
  updateProduct: async (handle, updates) => (await axios.put(`${API}/admin/products/${handle}`, updates, adminCfg)).data,
  updateSettings: async (updates) => (await axios.put(`${API}/admin/settings`, updates, adminCfg)).data,
  listInquiries: async () => (await axios.get(`${API}/admin/inquiries`, adminCfg)).data,
  listReviews: async () => (await axios.get(`${API}/admin/reviews`, adminCfg)).data,
  updateReview: async (id, status) => (await axios.put(`${API}/admin/reviews/${id}`, { status }, adminCfg)).data,
  overview: async () => (await axios.get(`${API}/admin/overview`, adminCfg)).data,
  updateContent: async (items) => (await axios.put(`${API}/admin/content`, { items }, adminCfg)).data,
  ordersCsvUrl: `${API}/admin/orders.csv`,
};
